import { connect, IAdFoxBannerOnErrorError } from '@cian/adfox-component';
import { withAdfoxPostViewAnalytics } from '@cian/postview-analytics-utils';
import React, { JSX, memo, useCallback, useMemo, useState } from 'react';

import { OwnTemplates } from './internal/components/OwnTemplates';
import { useAdfoxContext } from '../../utils/AdfoxContext';

const AdFoxBannerComponent = connect(OwnTemplates);

type AdFoxBannerProps = {
  galleryPosition?: number;
  position?: number;
  onClick?(event: MouseEvent): void;
  onView50Percent?(): void;
  onStub?(): void;
  onError?(error: IAdFoxBannerOnErrorError): void;
};

export const AdFoxBanner = memo<AdFoxBannerProps>(function AdFoxBanner(props) {
  const { onStub, onError, onClick, position, galleryPosition, onView50Percent } = props;

  const { params, sizes, postViewAnalyticsData } = useAdfoxContext();

  const [isHidden, setHidden] = useState(false);

  const handleStub = useCallback(() => {
    setHidden(true);

    onStub?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleError = useCallback((error: IAdFoxBannerOnErrorError) => {
    setHidden(true);

    onError?.(error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return useMemo((): JSX.Element | null => {
    if (isHidden) {
      return null;
    }

    const AdfoxWithPostView = withAdfoxPostViewAnalytics(AdFoxBannerComponent, {
      position,
      galleryPosition,
      onClick,
      onView1: onView50Percent,
      ...postViewAnalyticsData,
    });

    return <AdfoxWithPostView {...sizes} params={params} onStub={handleStub} onError={handleError} />;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHidden]);
});
